const IP_REGEX_PATTERN = String.raw`((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)`;
const CIDR_REGEX_PATTERN = String.raw`(/([0-9]|[1-2][0-9]|3[0-2]))`;

export const IP_WITH_CIDR_REGEX = new RegExp(`^${IP_REGEX_PATTERN}${CIDR_REGEX_PATTERN}$`);
export const IP_WITH_OPTIONAL_CIDR_REGEX = new RegExp(`^${IP_REGEX_PATTERN}${CIDR_REGEX_PATTERN}?$`);


export function createIPWithCIDR(ipAddress: string, cidr: string = '32'): string {
  return `${ipAddress}/${cidr}`;
}

export function normalizeIPToIPWithCIDR(ipAddress: string, cidr: string = '32'): string {
  if (IP_WITH_CIDR_REGEX.test(ipAddress)) {
    return ipAddress;
  } else if (IP_WITH_OPTIONAL_CIDR_REGEX.test(ipAddress)) {
    return createIPWithCIDR(ipAddress, cidr);
  } else {
    throw new Error(`Invalid IP address: ${ipAddress}`);
  }
}

// Checks whether any host bits are set for the CIDR mask, i.e. the value is not the network
// address itself (`10.0.0.0/24` is false, `10.0.0.1/24` is true). A bare IP is treated as `/32`.
export function hasHostBitsSetInCidr(ipWithCidr: string): boolean {
  if (!IP_WITH_OPTIONAL_CIDR_REGEX.test(ipWithCidr)) {
    throw new Error(`Invalid IP address or CIDR notation: ${ipWithCidr}`);
  }

  const [ip, prefixPart] = ipWithCidr.split('/');
  const prefix = prefixPart === undefined ? 32 : Number(prefixPart);
  const [a, b, c, d] = ip.split('.').map(Number);
  const ipInt = a * 16777216 + b * 65536 + c * 256 + d;
  const blockSize = 2 ** (32 - prefix);
  return ipInt % blockSize !== 0;
}
